<template>
  <div></div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="sass">

</style>